/* eslint-disable */
import React from 'react';
import {actions} from 'react-redux-form';
import {toast} from 'react-toastify';
import irelandApi from '../irelandApi';
import store, {history} from '../store';
import ToastMessage from '../components/common/toast-message';

const assembleUsergroup = (payLoad) => {
  const mPayLoad = {...payLoad};
  mPayLoad.permission_ids = [];
  Object.keys(payLoad.permission_ids).forEach((key) => {
    if (payLoad.permission_ids[key].checked) {
      mPayLoad.permission_ids.push(key);
    }
  });
  return mPayLoad;
};

export const getUserGroups = () => (dispatch) => {
  dispatch({type: 'GET_USERGROUP_LIST_PENDING'});
  return irelandApi.get('/api/admin/user_groups')
    .then((response) => {
      dispatch({type: 'GET_USERGROUP_LIST_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_USERGROUP_LIST_REJECTED', payLoad: error.data});
    });
};

export const getUserGroup = id => (dispatch) => {
  dispatch({type: 'GET_USERGROUP_PENDING'});
  const url = id ? `/api/admin/user_groups/${id}` : '/api/admin/user_groups/new';
  return irelandApi.get(url)
    .then((response) => {
      const traversePermissions = (permissions, parentId, result) => {
        permissions.forEach((perm) => {
          result[perm.id] = {checked: perm.checked, parent: parentId, children: perm.children.map(child => child.id)};
          traversePermissions(perm.children, perm.id, result);
        });
      };

      const attributes = response.data.data.attributes;
      const permissions = {};
      traversePermissions(attributes.permissions, undefined, permissions);
      const data = {
        name: attributes.name || '',
        permission_ids: permissions,
      };
      store.dispatch(actions.load('deep.admin_usergroup', data));
      dispatch({type: 'GET_USERGROUP_FULFILLED', payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_USERGROUP_REJECTED', payLoad: error.data});
    });
};

export const saveUserGroup = payLoad => irelandApi.post('/api/admin/user_groups/', {user_group: assembleUsergroup(payLoad)})
  .then((response) => {
    toast.success(<ToastMessage iconStyle="success" message="User group saved successfully"/>);
    history.push('/admin/user-groups');
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during save usergroup"/>);
    store.dispatch(actions.resetValidity('deep.admin_usergroup'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const updateUserGroup = (id, payLoad) => irelandApi.patch(`/api/admin/user_groups/${id}`, {user_group: assembleUsergroup(payLoad)})
  .then((response) => {
    toast.success(<ToastMessage iconStyle="success" message="User group saved successfully"/>);
    history.push('/admin/user-groups');
  })
  .catch((error) => {
    toast.error(<ToastMessage iconStyle="error" message="An error occurred during save usergroup"/>);
    store.dispatch(actions.resetValidity('deep.admin_usergroup'));
    const data = {
      ...error.response.data.errors
    };
    return Promise.reject(data);
  });

export const deleteUserGroup = id => (dispatch) => {
  dispatch({type: 'DELETE_USERGROUP_PENDING'});
  return irelandApi.delete(`/api/admin/user_groups/${id}`)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Usergroup has been deleted successfully"/>);
      dispatch({type: 'DELETE_USERGROUP_FULFILLED', payLoad: id});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during usergroup delete"/>);
      dispatch({type: 'DELETE_USERGROUP_REJECTED', payLoad: error.data});
      const data = {
        ...error.response.data
      };
      return Promise.reject(data);
    });
};



// WEBPACK FOOTER //
// ./src/actions/usergroups.js